import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { AddressDetails } from "../../PIForm/Steps/step3/PersonalAndFatca";
import Pep from "../../PIForm/Steps/step3/Pep";
import { useGetDataForForm } from "../../PIForm/Steps/hooks";
import { useFormInfo } from "../../PIForm/Steps/hooks/useFormInfo";
import { useLanguage } from "../../../hooks/useLanguage";
import useScrollToTop from "../../../hooks/useScrollToTop";
import Loader from "../../../shared/loaders/simpleLoader";
import NavButton from "../../piOnboarding/steps/common/button";
import { ROUTES } from "../../piOnboarding/steps/constants";
import {
  getClientTypeIdFromOnboardingToken,
  onboardingPath,
  redirectToPiOnboardingIdentification,
} from "../../piOnboarding/steps/helpers";
import { Wrapper } from "../../piOnboarding/steps/privateInformation/styles";
import { AddressAndPepWrapper } from "./styles";

const getInitialPerson = () => {
  try {
    return JSON.parse(localStorage.getItem("person") ?? "null");
  } catch {
    return null;
  }
};

function LoanPrivateInformation() {
  const [storedPerson] = useState(getInitialPerson);
  const person = storedPerson?.person ?? storedPerson;
  const legalAddress =
    person?.legalAddress ??
    person?.juridicalAddress ??
    storedPerson?.additionalInfo?.juridicalAddress ??
    "";

  const history = useHistory();
  const scrollToTop = useScrollToTop();
  const { contentLanguage } = useLanguage();
  const { trigger, setValue } = useFormContext();

  const onboardingToken = sessionStorage.getItem("onboardingToken");

  if (!onboardingToken) {
    redirectToPiOnboardingIdentification();
  }

  const clientTypeId = getClientTypeIdFromOnboardingToken();

  const { isLoading, ...restData } = useGetDataForForm({
    locale: contentLanguage,
    addressAndPepOnly: true,
  });

  const { isPep } = useFormInfo({ clientTypeId });

  useEffect(() => {
    setValue("legalAddress", legalAddress);
  }, [legalAddress, setValue]);

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);

  async function handleNext() {
    const isValid = await trigger();
    if (isValid) {
      history.push(onboardingPath(ROUTES.aboutServices));
    }
  }

  if (isLoading) {
    return (
      <div style={{ marginTop: "32px" }}>
        <Loader />
      </div>
    );
  }

  return (
    <Wrapper>
      <AddressAndPepWrapper>
        <AddressDetails
          fullCountries={restData.fullCountries}
          cities={restData.cities}
          transFormedCityOrVillage={restData.transFormedCityOrVillage}
          juridicalAddressDisabled={Boolean(legalAddress)}
        />
        <Pep pepCategory={restData.pepCategory} person={person} isPep={isPep} />
      </AddressAndPepWrapper>
      <NavButton handleNext={handleNext} />
    </Wrapper>
  );
}

export default LoanPrivateInformation;
